/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Current_Password_WrongInputs */

const en_error_current_password_wrong = /** @type {(inputs: Error_Current_Password_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The password isn't right.`)
};

/**
* | output |
* | --- |
* | "The password isn't right." |
*
* @param {Error_Current_Password_WrongInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_current_password_wrong = /** @type {((inputs?: Error_Current_Password_WrongInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Current_Password_WrongInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_current_password_wrong(inputs)
});